<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: 'Match Universe',
          defaultValue: 1,
          key: 'matchUniverse',
          selectList: [
            {
              id: 1,
              name: 'All Businesses',
            },
            {
              id: 2,
              name: 'In Date Financials Only',
            },
            {
              id: 3,
              name: 'Major Buinesses Only',
            },
          ],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          type: 'input',
          label: 'Phone Number',
          key: 'mobile',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  methods: {
    async validate() {
      return await this.$refs.form.validateForm()
    },
  },
  components: {
    MForm,
  },
}
</script>
